<template>
	<div class="flex flex-col items-center justify-center p-8 min-h-[300px]">
		<ProgressSpinner style="width: 50px; height: 50px" strokeWidth="4" fill="var(--surface-ground)"
			animationDuration="1s" />
		<h2 class="text-xl mt-4 text-gray-800">Wird geladen...</h2>
		<p class="text-gray-600 mt-2 text-center">
			Einen Moment bitte, wir bereiten alles für dich vor.
		</p>
	</div>
</template>

<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner';
</script>
